<template>
  <tr v-if="!showItem" @click="showing">

    <td>

      <span v-if="confirmed">
        <v-tooltip
          left 
          color="secondary" 
          content-class="caption" 
          transition="slide-x-transition"
          >
            <template v-slot:activator="{on}">
              <v-btn v-on="on" @click="unPick">
                <v-icon :color="getIconColor('assigned')" small>{{getIcon('assigned')}}</v-icon>
              </v-btn>
            </template>
            <span>Deassign {{pickPersonName}} from "{{targetPersonName}}"</span>
        </v-tooltip>
      </span>
      <span v-else>
        <v-tooltip
          left 
          color="secondary" 
          content-class="caption" 
          transition="slide-x-transition"
          >
            <template v-slot:activator="{on}">
              <v-btn v-on="on" @click="pick">
                <v-icon :color="getIconColor(whichPick)" small>{{getIcon('pick')}}</v-icon>
              </v-btn>
            </template>
            <span>Pick {{pickPersonName}} as "{{targetPersonName}}"</span>
        </v-tooltip>
      </span>
    </td>
   
    <td>
      <person-tipper-click
        :make-person-match="makePersonMatch"
        :target-type="targetType"
        :matching-row="matchingRow"
        @showing="showing"
      >
      </person-tipper-click>
    </td>

    <td>
      <matches 
        v-if="matchReasons"
        :match-reasons="matchReasons" 
        class="text-xs-left" 
        compressed 
        :row-type="targetType"
        :clickable="false"
        @showing="showing"
        emit="showing"
      ></matches>
    </td>

    <td>
      <reason v-if="makePersonReason"
        :reason="makePersonReason"
        item-type="person"
        compressed
        :clickable="false"
        @showing="showing"
        emit="showing"
      ></reason>
    </td>

  </tr>
  <tr v-else-if="showProfessionTable">
    <td>
      <table-person-to-films
        v-if="makePersonMatch"
        :targetType="targetType"
        :makePersonMatch="makePersonMatch"
        :personProfessions="personProfessions"
        :reason="reason"
        :filmID="filmID"
        :personID="personID"
        :matchingRow="matchingRow"
        :targetItem="targetItem"
        @showing="showing"
        @save="dialogSave"
        @cancel="dialogCancel"
      >
      </table-person-to-films>

    </td>
  </tr>
</template>
<script>
import Persontipperclick from '@/components/Persontipperclick'
import Matches from '@/components/Matches'
import Reason from '@/components/Reason'
import Tablepersontofilms from '@/components/Tablepersontofilms'
import { SearchUtils } from '@/js'
import { getIconColor, getIcon, settings } from '@/js/store'

export default {
  props: {
    matchingRow: Object,
    reason: Object,
    showItem: Object,
    targetItem: Object
  },
  components: {
    'matches': Matches,
    'reason': Reason,
    'person-tipper-click': Persontipperclick,
    'table-person-to-films': Tablepersontofilms
  },
  data: () => ({
    targetType: 'person'
  }),
  methods: {
    pickEmit (personID) {
      this.$emit('pick', {
        personID,
        id: this.targetItem.id,
        targetItem: this.targetItem
      })
      // automatically enter the the profession table in case anything needs done there
      this.showEmit(false)

    },
    unPick () {
      this.pickEmit(null)
    },
    pick () {
      this.pickEmit(this.personID)
    },
    dialogCancel () {
      this.showEmit(false)
    },
    dialogSave () {
      // do mutation then close
      this.showEmit(false)
    },
    showing () {
      this.showEmit (!this.showProfessionTable)
    },
    showEmit (b) {
      this.$emit('showing', b ? this.matchingRow : null)
    },
    getIconColor (thing) {
      return getIconColor(thing)
    },
    getIcon (thing) {
      return getIcon(thing)
    },
  },
  computed: {
    whichPick () {
      return this.isAssigned ? 'waitassign' : 'pick'
    },
    pickPersonName () {
      const reason = this.matchReasons && this.matchReasons[0]
      return reason ? SearchUtils.getBigTextFromReason({
        reason,
        maxListShow: settings.maxListShow
      }) : null
    },
    targetPersonName () {
      return this.targetItem && this.targetItem.person
    },
    targetPersonID () {
      return this.targetItem && this.targetItem.personID
    },
    confirmed () {
      // targetItem is the callsheetanalyis item
      // reason is the film details
      // personID is the potential match id
      // so a confirmed item is where the personID matches the targetItem.personID
      return this.personID === this.targetPersonID
    },
    isAssigned () {
      return this.personID
    },
    // it the item matches the current - then we need to show a profession table
    showProfessionTable () {
      return this.showItem && this.matchingRow && this.showItem.itemID === this.matchingRow.itemID
    },
    color () {
      return getIconColor(this.targetType)
    },
    personID () {
      return this.makePersonMatch && this.makePersonMatch.Person && this.makePersonMatch.Person.id
    },
    makePersonMatch () {
      if(!this.matchingRow) return null    
      return {
        matchType: this.matchingRowType,
        matchID: this.matchingRowID,
        match: this.matchingRowName,
        Person: {
          id: this.matchingRowID,
          firstName: this.matchingRowName
        }
      }
    },
    // fakes a person reason from a film
    makePersonReason () {
      // but only if the person matches 

      if(!this.personProfessions || !this.personProfessions.length) return null
      const mats= SearchUtils.makeMatchReasonsFromItem({
        makeType: 'person', 
        makeBase: this.personProfessions,
        item: this.matchingRow
      })
      if (!mats || !mats.length) {
        console.error ('unexpected mats',mats)
      }
      return (mats && mats[0]) || null
    },
    matchingRowName () {
      return this.matchingRow && this.matchingRow.itemName
    },
    matchingRowID () {
      return this.matchingRow && this.matchingRow.itemID
    },
    matchingRowType () {
      return this.matchingRow && this.matchingRow.itemType
    },
    matchReasons () {
      return this.matchingRow && this.matchingRow.MatchReasons
    },
    film () {
      // we already have lots of stuff about the film, so we can look see if this guy is already assigned
      return this.reason && this.reason.Film
    },
    filmID () {
      return this.film && this.film.id
    },
    people () {
      return this.film && this.film.FilmToPeople
    },
    personProfessions () {
      const fp = this.people && 
        this.people.filter(f=>f.Person && f.Person.id === this.matchingRowID)
      return fp 
    }
  }
}
</script>
